module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    staticClass: "hold-transition login-page"
  }, [_c('div', {
    staticClass: "login-box rg-box m-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box login-bbox"
  }, [_c('div', {
    staticClass: "box-body register-card-body pd-20"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "hidden": !_vm.firstStepText
    }
  }, [_vm._v("\n          Welcome to the Rubbermaid Commercial Products Smart App Registration page.\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "13px"
    },
    attrs: {
      "hidden": !_vm.firstStepText
    }
  }, [_vm._v("\n          Please follow the "), _c('span', {
    staticStyle: {
      "font-weight": "700",
      "color": "#fecd2f"
    }
  }, [_vm._v("3 step")]), _vm._v(" registration process to complete registration\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "finalsteps",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "hidden": !_vm.thirdStepText
    }
  }, [_vm._v("\n          Thank You for your registration, one of our team members will review your details and will grant access within "), _c('span', {
    staticStyle: {
      "color": "#fecd2f"
    }
  }, [_vm._v("12-24 hours.")])]), _vm._v(" "), _c('form', {
    staticClass: "row-rm-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('md-steppers', {
    attrs: {
      "md-active-step": _vm.active,
      "md-linear": ""
    },
    on: {
      "update:mdActiveStep": function($event) {
        _vm.active = $event
      },
      "update:md-active-step": function($event) {
        _vm.active = $event
      }
    }
  }, [_c('md-step', {
    staticClass: "stepper1",
    attrs: {
      "id": "first",
      "md-editable": false,
      "md-label": "Step",
      "step": "5",
      "md-done": _vm.first
    },
    on: {
      "update:mdDone": function($event) {
        _vm.first = $event
      },
      "update:md-done": function($event) {
        _vm.first = $event
      }
    }
  }, [_c('md-field', {
    staticClass: "title",
    class: _vm.getValidationClass('title')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Title*")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "title",
      "id": "title",
      "placeholder": "Title*"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "Mr."
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Mrs."
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Miss."
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Other"
    }
  }, [_vm._v("Other")])], 1), _vm._v(" "), (this.backendValidationform.title.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.title.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('first_name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("First Name*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "first_name",
      "id": "first_name",
      "placeholder": "First Name*"
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), (!_vm.$v.form.first_name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The first name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.first_name.required && this.backendValidationform.first_name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.first_name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('last_name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Last Name*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "last_name",
      "id": "last_name",
      "placeholder": "Last Name*"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  }), _vm._v(" "), (!_vm.$v.form.last_name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The last name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.last_name.required && this.backendValidationform.last_name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.last_name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('org_name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Organization Name*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "org_name",
      "id": "org_name",
      "placeholder": "Organization Name*"
    },
    model: {
      value: (_vm.form.org_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "org_name", $$v)
      },
      expression: "form.org_name"
    }
  }), _vm._v(" "), (!_vm.$v.form.org_name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The last name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.org_name.required && this.backendValidationform.org_name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.org_name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('email')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Email*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "email",
      "id": "email",
      "placeholder": "Email* (will be used as user name)"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), (!_vm.$v.form.email.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The email is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.email.required && this.backendValidationform.email.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.email.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('phone_no')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Phone Number*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "phone_no",
      "id": "phone_no",
      "placeholder": "Phone Number*"
    },
    model: {
      value: (_vm.form.phone_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone_no", $$v)
      },
      expression: "form.phone_no"
    }
  }), _vm._v(" "), (!_vm.$v.form.phone_no.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The phone Number is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.phone_no.required && this.backendValidationform.phone_no.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.phone_no.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('state_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("State")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "state_id",
      "id": "state_id"
    },
    model: {
      value: (_vm.form.state_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "state_id", $$v)
      },
      expression: "form.state_id"
    }
  }, _vm._l((_vm.CountryList), function(item) {
    return _c('md-optgroup', {
      key: item.id,
      attrs: {
        "label": item.name
      }
    }, _vm._l((item.states), function(item2) {
      return _c('md-option', {
        key: item2.id,
        attrs: {
          "value": item2.id
        }
      }, [_vm._v(_vm._s(item2.name))])
    }), 1)
  }), 1), _vm._v(" "), (!_vm.$v.form.state_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The State is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.state_id.required && this.backendValidationform.state_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.state_id.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "rgbtnn btn btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.disableNextButton
    },
    on: {
      "click": _vm.validateFirstStep
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('p', {
    staticClass: "mb-1 rg-center"
  }, [_c('spam', [_vm._v("Already have an account?\n                        "), _c('router-link', {
    staticClass: "btn-signup",
    staticStyle: {
      "color": "red !important"
    },
    attrs: {
      "to": "/user/login"
    }
  }, [_vm._v("Sign in")]), _vm._v("\n                        here!")], 1)], 1)])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "second",
      "md-editable": false,
      "md-label": "Step",
      "md-error": _vm.secondStepError,
      "md-done": _vm.second
    },
    on: {
      "update:mdDone": function($event) {
        _vm.second = $event
      },
      "update:md-done": function($event) {
        _vm.second = $event
      }
    }
  }, [_c('md-field', {
    class: _vm.getValidationClass('password')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Password*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "Password*"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pw-info md-error",
    style: (_vm.$v.form.password.required && this.backendValidationform.password.isError ? 'color:red;' : 'color: gray;')
  }, [_vm._v("Password must contain at least:\n                    6 Characters, 1 Uppercase letter, 1 Lowercase letter, 1 Special Character and 1 number")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-field', {
    staticClass: "password_confirmation",
    class: _vm.getValidationClass('password_confirmation')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Confirm Password*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "id": "password_confirmation",
      "placeholder": "Confirm Password*"
    },
    model: {
      value: (_vm.form.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.form, "password_confirmation", $$v)
      },
      expression: "form.password_confirmation"
    }
  }), _vm._v(" "), (!_vm.$v.form.password_confirmation.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The confirm password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.password_confirmation.required && this.backendValidationform.password_confirmation.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationform.password_confirmation.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "agry_ul"
  }, [_c('li', {
    staticClass: "agry_li"
  }, [_c('md-checkbox', {
    staticClass: "ul-check md-primary md-size-10 radio-regist",
    model: {
      value: (_vm.form.terms_and_condition),
      callback: function($$v) {
        _vm.$set(_vm.form, "terms_and_condition", $$v)
      },
      expression: "form.terms_and_condition"
    }
  }, [_vm._v("I agree to the")]), _vm._v(" \n                        ")], 1), _vm._v(" "), _c('li', {
    staticClass: "agry_li"
  }, [_c('router-link', {
    staticClass: "scnd_lr",
    staticStyle: {
      "margin-top": "-5px",
      "font-size": "12px",
      "font-weight": "500"
    },
    attrs: {
      "to": {
        name: 'Terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" \n                        ")], 1), _vm._v(" "), _c('li', {
    staticClass: "agry_li"
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "500"
    }
  }, [_vm._v(" of this Application.")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "agry_ul"
  }, [_c('li', {
    staticClass: "agry_li"
  }, [_c('md-checkbox', {
    staticClass: "ul-check md-primary md-size-10 radio-regist",
    model: {
      value: (_vm.form.privacy_policy),
      callback: function($$v) {
        _vm.$set(_vm.form, "privacy_policy", $$v)
      },
      expression: "form.privacy_policy"
    }
  }, [_vm._v("Any personal information you provide to us when registering to use this application will be collected in accordance with our")]), _vm._v(" \n                        ")], 1), _vm._v(" "), _c('li', {
    staticClass: "agry_li",
    staticStyle: {
      "margin-top": "-7px"
    }
  }, [_c('router-link', {
    staticClass: "scnd_lr",
    staticStyle: {
      "margin-top": "-5px",
      "margin-left": "155px",
      "font-size": "12px",
      "font-weight": "500"
    },
    attrs: {
      "to": {
        name: 'Privacy'
      },
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-checkbox', {
    staticClass: "md-primary md-size-10 radio-regist",
    model: {
      value: (_vm.form.marketing_agreement),
      callback: function($$v) {
        _vm.$set(_vm.form, "marketing_agreement", $$v)
      },
      expression: "form.marketing_agreement"
    }
  }, [_vm._v("\n                     I wish to receive marketing communications from Newell Australia Pty\n                    Limited and I understand I can opt-out of receiving such marketing\n                    communications at any time using the unsubscribe facility\n                    provided in the marketing communication or by contacting Newell Australia Pty Limited.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    staticClass: "rgbtnn btn btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.disableRegisterButton
    },
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("Register")])])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "third",
      "md-editable": false,
      "md-label": "Step",
      "md-error": _vm.thirdStepError,
      "md-done": _vm.third
    },
    on: {
      "update:mdDone": function($event) {
        _vm.third = $event
      },
      "update:md-done": function($event) {
        _vm.third = $event
      }
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', [_vm._v("Thank you for registering!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                  Our team is currently verifying your details. Your account will be activated within the next 12-24 hours.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                  We have sent you a confirmation email. If you haven’t received the email, please check your junk folder.\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('router-link', {
    staticClass: "rgbtnn btn btn btn-primary btn-block",
    staticStyle: {
      "color": "#fff !important"
    },
    attrs: {
      "to": "/user/login"
    }
  }, [_vm._v("Ok")])], 1)])], 1)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    staticClass: "logo-login-signup",
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP_Smart_App.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4df08df2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserRegistrationView.vue
// module id = 2090
// module chunks = 1